/**
 * Results tooltip dictionary
 */
export const resultsTooltip = {
  balance_end: 'Saldo inicial total e de cada conta bancária, a partir do primeiro dia do mês analisado.',
  balance_start: 'Saldo final total e de cada conta bancária, no último dia do mês analisado.',
  contribution_margin: `
    Valor que sobra após o pagamento de todos os custos. Usado para manter o negócio e lucrar.<br>
    Cálculo: Receita líquida menos tudo que é custo.<br>
    <strong>Dica da Caixa:</strong> Margem baixa pode indicar que o preço está baixo ou os custos estão altos demais.
  `,
  net_revenues: `
    Valor de receita que sobra depois de tirar os redutores das vendas, como impostos e devoluções.<br>
    Cálculo: Receita bruta menos tudo que reduz esse valor (redutores).<br>
    <strong>Dica da Caixa:</strong> É o faturamento da empresa. Se este valor cair, pode ser por causa de muitos descontos, abatimentos ou devoluções.
  `,
  costs: `
    Gastos necessários para fabricar um produto ou prestar um serviço, como materia prima, fornecedores, vendedores e etc.<br>
    Cálculo: Soma de todos os gastos da empresa para produzir, que podem ser fixos ou variar com a produção.<br>
    <strong>Dica da Caixa:</strong> Se o valor de custo aumentou, pode ser uma boa hora de renegociar com seus fornecedores ou rever o processo de produção.
  `,
  net_result: `
    Resultado total da empresa no mês, levando em conta tudo: vendas, impostos, entradas e saídas de dinheiro.<br>
    Cálculo: Resultado final após somar os lucros não evetuais mais o valor de resultado da operação e subtrair o valor de gastos não recorrentes.<br>
    <strong>Dica da Caixa:</strong> Mostra se a empresa teve lucro ou prejuízo no mês. Fique atento a quedas frequentes!
  `,
  non_operational_expenses: `
    Gastos não recorrentes ou financeiross, como juros de empréstimos, multas, etc.<br>
    Cálculo: Soma de todos os gastos não reccorentes.<br>
    <strong>Dica da Caixa:</strong> Valor que deve ser observado para evitar surpresas e impactos no caixa.
  `,
  non_operational_revenues: `
    Lucros eventuais que não vêm das atividades principais, como aplicações, venda de ativos, etc.<br>
    Cálculo: Soma de todos os lucros eventuais.<br>
    <strong>Dica da Caixa:</strong> Valores pontuais, observe se a empresa não está dependendo dele para fechar o mês.
  `,
  operational_expenses: `
    Gastos com o objetivo de auxiliar a área administrativa, comercial, financeira e/ou infraestrutura da empresa.<br>
    Cálculo: Soma de gastos da empresa que não estão ligados à produção.<br>
    <strong>Dica da Caixa:</strong> Se o valor de despesa aumentar muito, pode ser hora de cortar gastos ou buscar mais eficiência.
  `,
  operational_result: `
    Lucro ou prejuízo vindo das atividades principais da empresa, sem incluir taxas financeiras ou impostos.<br>
    Cálculo: Margem de contribuição menos as despesas da operação.<br>
    <strong>Dica da Caixa:</strong> Se o resultado for negativo, pode indicar que a empresa está tendo mais despesas do que receita.
  `,
  reducers: `
    Valores que reduzem a receita bruta como descontos concedidos, impostos sobre vendas (ex: ICMS e ISS), devoluções e abatimentos.<br>
    Cálculo: Valor percentual médio baseado no total bruto de entradas.<br>
    <strong>Dica da Caixa:</strong> Se estes valores estiverem altos, pode ser sinal de muitos descontos ou problemas com devoluções.
  `,
  result_after_taxes: `
    Resultado da operação após pagamento dos impostos.<br>
    Cálculo: Valor do resultado de operação menos o valor de impostos.<br>
    <strong>Dica da Caixa:</strong> Este valor mostra o que realmente sobrou no final do mês. Importante para saber a saúde financeira da sua empresa!
  `,
  revenues: `
    Valor total de vendas ou serviços prestados antes de qualquer dedução.<br>
    Cálculo: Soma de todos os valores de entrada do mês.<br>
    <strong>Dica da Caixa:</strong> Se este valor estiver baixo, pode ser queda nas vendas ou necessidade de divulgar mais os seus produtos e serviços.
  `,
  taxes: `
    Impostos que a empresa paga sobre o seu lucro, como o IRPJ e a CSLL.<br>
    Cálculo: Porcentagem do valor que a empresa lucrou (se houver lucro).<br>
    <strong>Dica da Caixa:</strong> Se o valor de impostos estiver alto pode reduzir os lucros da empresa. Revise seu regime tributário.
  `,
};
